const menuUrls = {
  "Pokémon":    "/collections/pokemon",
  //"Yu-Gi-Oh!":  "/collections/yu-gi-oh",
  //"Gundam":     "/collections/gundam",
  //"Accesorios": "/collections/accesorios",
};

// ── Menú desktop (inline) ──────────────────────────────────────────
const inlineMenu = document.querySelector(".header__inline-menu");
if (inlineMenu) {
  inlineMenu.querySelectorAll("details").forEach((item) => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });

    const summary = item.querySelector("summary");
    if (summary) {
      const label = summary.textContent.trim();
      const targetUrl = menuUrls[label];
      if (targetUrl) {
        summary.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = targetUrl;
        });
      }
    }
  });
}

// ── Menú drawer (mobile) ───────────────────────────────────────────
const drawerMenu = document.querySelector("#menu-drawer");
if (drawerMenu) {
  drawerMenu.querySelectorAll("details").forEach((details) => {
    const summary = details.querySelector(":scope > summary");
    if (!summary) return;

/* Bloque original
    summary.addEventListener("click", (e) => {
      e.preventDefault();

      const rect = summary.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const isCaretSide = clickX > rect.width / 2.5;  //Distancia entre los elementos interactivos (Menú/Caret)

      if (isCaretSide) {
        details.hasAttribute("open")
          ? details.removeAttribute("open")
          : details.setAttribute("open", "");
      } else {
        const label = summary.querySelector(".az-menu-title")?.textContent.trim();
        const url = menuUrls[label];
        if (url) window.location.href = url;
      }
    });
*/

/* Límita los elementos interactivos dependiendo de la posición del caret */
    summary.addEventListener("click", (e) => {
      e.preventDefault();

      const titleEl = summary.querySelector(".az-menu-title");
      const dividerEl = summary.querySelector(".az-divider");

      // La línea divisora marca el límite entre las dos zonas
      const dividerRect = dividerEl?.getBoundingClientRect();
      const isCaretSide = dividerRect && e.clientX >= dividerRect.left;

      if (isCaretSide) {
        details.hasAttribute("open")
          ? details.removeAttribute("open")
          : details.setAttribute("open", "");
      } else {
        const label = titleEl?.textContent.trim();
        const url = menuUrls[label];
        if (url) window.location.href = url;
      }
    });
  });
}